import { IFluidObject } from '@fluidframework/core-interfaces';
import { PermissionService } from '@fluidx/office-fluid-types';
import { PostMessageSender, PostMessageHandlerFactory } from '../Shared/PostMessage';
import {
  CheckUserAccessCalledMessage,
  CheckUserAccessReturnedMessage,
  GrantUserAccessCalledMessage,
  GrantUserAccessReturnedMessage,
  PairingValue
} from '../MessageTypes';
import { resolveOrRejectReply } from './ShareServiceProxy';

/**@deprecated */
export function getHostSidePermissionService(
  scope: IFluidObject
): {
  scopePairingValue?: PairingValue<Promise<PermissionService>>;
  scopeHandler?: PostMessageHandlerFactory;
} {
  const permissionServicePromise = scope.PermissionServicePromise;
  if (!permissionServicePromise) {
    return {};
  }

  return {
    scopePairingValue: { found: true },
    scopeHandler: (sender: PostMessageSender) => {
      return {
        ['CheckUserAccessCalled']: async (message) => {
          const { userPrincipalName } = (message as CheckUserAccessCalledMessage).payload;
          const result = await (await permissionServicePromise).checkUserAccess(userPrincipalName);
          const reply: CheckUserAccessReturnedMessage = {
            payload: { result }
          };
          sender.sendReply(message, reply);
        },
        ['GrantUserAccessCalled']: async (message) => {
          const { recipientUPNs } = (message as GrantUserAccessCalledMessage).payload;
          const result = await (await permissionServicePromise).grantPermissions(recipientUPNs);
          const reply: GrantUserAccessReturnedMessage = {
            payload: { result }
          };
          sender.sendReply(message, reply);
        }
      };
    }
  };
}

/**@deprecated */
export function getGuestSidePermissionService(sender: PostMessageSender): Promise<PermissionService> {
  const PermissionServicePromise: Promise<PermissionService> = Promise.resolve({
    get PermissionServicePromise(): Promise<PermissionService> {
      return Promise.resolve(this);
    },
    checkUserAccess(userPrincipalName: string): Promise<boolean> {
      const message: CheckUserAccessCalledMessage = {
        type: 'CheckUserAccessCalled',
        payload: { userPrincipalName }
      };
      return sender.sendWithReturn(message).then((reply) => {
        return resolveOrRejectReply(reply as CheckUserAccessReturnedMessage);
      });
    },
    grantPermissions: (recipientUPNs: string[]): Promise<boolean> => {
      const message: GrantUserAccessCalledMessage = {
        type: 'GrantUserAccessCalled',
        payload: { recipientUPNs }
      };
      return sender.sendWithReturn(message).then((reply) => {
        return resolveOrRejectReply(reply as GrantUserAccessReturnedMessage);
      });
    }
  });
  return PermissionServicePromise;
}

// cspell:ignore UPNs
